<div class="container" [matTooltip]="tooltip">
@for (user of getUsersWithAccess(item); track user) {
    @if ($index < 2) {
        <frmg-user-logo
                [ngClass]="{'owner': item.user.email !== currentUser.email && $index == 0}"
                [user]="user"
        ></frmg-user-logo>
    }
    @if ($index === 2) {
        <frmg-user-logo [user]="moreUsers(item)"
                        class="more-users"
        ></frmg-user-logo>
    }
}
</div>